export const SITES = {
  HAMI: {
    copyright: '哈密伊吾融合算力云',
    logo: require('@scope/images/hami_logo.png'),
    loginLogo: require('@scope/images/hami_logo.png'),
    name: '哈密伊吾融合算力云',
    login_page_slogan: '哈密伊吾融合算力云',
    domains: ['hm.atcloud.xyz'],
  },
  LTC: {
    copyright: '联泰集群（北京）科技有限公司',
    logo: require('@scope/images/liantai_logo.png'),
    loginLogo: require('@scope/images/liantai_full_logo.png'),
    name: '联泰算力云',
    login_page_slogan: '联泰算力云',
    domains: ['lthpc.atcloud.xyz'],
  },
}
